import { APIS, URLS } from '@/shared/config/urls';
import type { UnmappedSitesRoadResponse } from '@/shared/types/unmapped-site-road';
import { request } from '@/shared/utils/request';

export const fetchUnmappedSiteRoad = async (
  params: string = ''
): Promise<UnmappedSitesRoadResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.unmappedSiteRoad(params)}`;
  return await request.get(url);
};
